import React from 'react'
import {
	Orders,
	Order,
	OrderId,
	OrderDate,
	Arrow,
	OrderPrice,
	OrderQuantity,
} from './style'

export const OrderLoader = ({ quantity = 20 }) => {
	return (
		<Orders>
			{Array(quantity)
				.fill('')
				.map((i, idx) => (
					<Order key={idx}>
						<div>
							<OrderId />
							<OrderDate />
						</div>
						<div className='d-flex justify-content-center'>
							<Arrow />
						</div>
						<div className='d-flex align-items-end flex-column'>
							<OrderPrice />
							<OrderQuantity />
						</div>
					</Order>
				))}
		</Orders>
	)
}
